import { FormControl, FormGroup } from '@angular/forms'

export type timeFrameType = 'day' | 'week' | 'month' | 'two_months' | 'quarter' | 'six_months' | 'year'
export type Statistic = {
  name: string
  category: boolean
  icon: string
  graph_type: number
  event_size: Array<string>
  time_frame: Array<timeFrameType>
}

export type Statistics = Statistic[]

export interface StatisticWithForm extends Statistic {
  form: FormGroup
  checkbox?: FormControl
}

export interface StatisticWithDisplayData extends StatisticWithForm {
  displayData: StatisticResponse
}

export interface StatisticState {
  id: string
  value: unknown
}

export class StatisticResponse {
  first: string = ''
  percentage: number = NaN
  second: string = ''
  third: string = ''
  date: string = ''
}
